/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Sesso utente come ricevuto dai provider federati SPID/CIE-ID. I valori ammessi sono M ed F; null indica non dichiarato.
 */
export enum Sesso {

    M = 'M',

    F = 'F'
}

